import { LockOutlineIcon } from '../icons';

/** Kept at this path because several callers import it by this name. */
export const LockIcon = LockOutlineIcon;
